export default __webpack_public_path__ + "static/media/innerBannerBg.6ca6c89d.jpg";